class StorageService {
  static KEYS = {
    CHAT_HISTORY: 'studybot_chat_history',
    SETTINGS: 'studybot_settings',
    LANGUAGE: 'studybot_language',
    THEME: 'studybot_theme'
  };

  static MAX_MESSAGES = 100; // Maximum number of messages to store

  static saveMessages(messages) {
    try {
      // Keep only the last MAX_MESSAGES messages
      const trimmedMessages = messages.slice(-this.MAX_MESSAGES);
      localStorage.setItem(this.KEYS.CHAT_HISTORY, JSON.stringify(trimmedMessages));
    } catch (error) {
      console.error('Error saving messages to localStorage:', error);
    }
  }

  static getMessages() {
    try {
      const messages = localStorage.getItem(this.KEYS.CHAT_HISTORY);
      return messages ? JSON.parse(messages) : [];
    } catch (error) {
      console.error('Error reading messages from localStorage:', error);
      return [];
    }
  }

  static saveSettings(settings) {
    try {
      localStorage.setItem(this.KEYS.SETTINGS, JSON.stringify(settings));
    } catch (error) {
      console.error('Error saving settings to localStorage:', error);
    }
  }

  static getSettings() {
    try {
      const settings = localStorage.getItem(this.KEYS.SETTINGS);
      return settings ? JSON.parse(settings) : {
        standard: 'Not specified',
        subject: 'Not specified',
        method: 'Not specified',
        language: 'English'
      };
    } catch (error) {
      console.error('Error reading settings from localStorage:', error);
      return {
        standard: 'Not specified',
        subject: 'Not specified',
        method: 'Not specified',
        language: 'English'
      };
    }
  }

  static saveLanguage(language) {
    try {
      localStorage.setItem(this.KEYS.LANGUAGE, language);
    } catch (error) {
      console.error('Error saving language to localStorage:', error);
    }
  }

  static getLanguage() {
    return localStorage.getItem(this.KEYS.LANGUAGE) || 'English';
  }

  static saveTheme(theme) {
    try {
      localStorage.setItem(this.KEYS.THEME, theme);
    } catch (error) {
      console.error('Error saving theme to localStorage:', error);
    }
  }

  static getTheme() {
    return localStorage.getItem(this.KEYS.THEME) || 'light';
  }

  static clearAll() {
    try {
      Object.values(this.KEYS).forEach(key => localStorage.removeItem(key));
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  }
}

export default StorageService;
